import { post } from "aws-amplify/api";
import type {
  AuthValidationResult,
  ValidateAuthenticatedUser,
} from "./AuthProvider";

type CurrentUserInfo = {
  email?: string;
};

type CurrentUserProvisionValidatorOptions = {
  apiName?: string;
  notProvisionedMessage?: (userSub: string) => string;
};

export function createCurrentUserProvisionValidator({
  apiName = "apiVeroUser",
  notProvisionedMessage = (userSub) =>
    `User ${userSub} not found. Please contact support.`,
}: CurrentUserProvisionValidatorOptions = {}): ValidateAuthenticatedUser {
  return async ({ user }) => {
    const { body } = await post({
      apiName,
      path: "/list",
      options: {
        body: {
          meth: "getCurrentUserInfo",
        },
      },
    }).response;
    const data = (await body.json()) as CurrentUserInfo;

    if (!data.email) {
      return {
        ok: false,
        message: notProvisionedMessage(user.sub),
      };
    }

    return { ok: true } satisfies AuthValidationResult;
  };
}
